module.exports = __webpack_public_path__ + "static/media/comingsoon.1ed867cd.png";